import { useUserQuery } from "@/checkout/graphql";

/** Module-level constant — inline `{ suspense: false }` creates a new object every render → React #301.
 *  The checkout urql client uses `suspense: true`; this per-query override prevents useUserQuery
 *  from throwing into the RootViews `<Suspense>` boundary and unmounting the checkout tree. */
const noSuspenseContext = { suspense: false as const };

export const useUser = () => {
	const [{ data, fetching: loading, stale }] = useUserQuery({ context: noSuspenseContext });

	const user = data?.user;

	const authenticated = !!user?.id;

	return { user, loading: loading || stale, authenticated };
};
